import React from 'react';

export default function ConversionFlowSummary({ summary }) {
    return (
        <>
            {Object.entries(summary?.categories || {})?.map(([key, category]) => (
                <div key={key} className="col-12">
                    <div className="row gutters-0">
                        {category?.title && (
                            <div className="col-12">
                                <p className="text--20">
                                    {category?.title}
                                </p>
                            </div>
                        )}

                        {Object.entries(category?.values || {})?.map(([key, value], index) => (
                            <React.Fragment key={key}>
                                <div className={`col-6 py-1 py-lg-2 ${index === 0 ? '' : 'border-top'}`}>
                                    <p className="text--16 text-muted--60">{value?.label}</p>
                                </div>
                                <div className={`col-6 py-1 py-lg-2 ${index === 0 ? '' : 'border-top'}`}>
                                    <p className="text--16">{value?.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
        </>
    )
}
